// External libraries
import React from 'react';
import styled, { withTheme } from 'styled-components';
import noop from 'lodash/noop';

// Zocdoc libraries
import { MetricsClickable } from '@zocdoc/frontend-metrics';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { Link } from '@zocdoc-frontend-common/components-link';

const bannerTheme = props => props.theme.components.PrivacyUpdateBanner; //Reuse Privacy Update Banner settings

export const BannerContainer = styled.div`
    background-color: ${props => bannerTheme(props).bgColor};
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    height: 48px;
    box-sizing: border-box;
    padding: 10px;
    transition: height 0.6s ease-in-out, padding 0.6s ease-in-out;
`;

const BannerContents = styled.div`
    color: ${props => bannerTheme(props).textColor};
    font-family: ${FontFamily.SharpSansSemibold};
    text-align: center;
    opacity: 1;
    transition: opacity 0.3s ease-in-out;
`;

const BannerMessage = styled.span`
    &::after {
        content: ' ';
    }
`;

export const AlertBannerView = withTheme(
    ({ url, message, linktext, theme, onClick = noop }) => {
        return (
            <BannerContainer data-test="alert-banner">
                <BannerContents data-test="alert-banner-contents">
                    <BannerMessage>{message}</BannerMessage>
                    <MetricsClickable>
                        <InlineBlockLink
                            data-test="alert-banner-link"
                            href={url}
                            target="_blank"
                            onClick={onClick}
                        >
                            {linktext}
                        </InlineBlockLink>
                    </MetricsClickable>
                </BannerContents>
            </BannerContainer>
        );
    }
);

//if the Link is inline-block, it'll stay together when wrapping in mobile mode.
const InlineBlockLink = styled(Link)`
    display: inline-block;
`;

export default AlertBannerView;
